export const useDrawer = () => {
  const shouldShow = useState(() => ref(true))

  const toggleDrawer = () => {
    shouldShow.value = !shouldShow.value
  }

  const openDrawer = () => {
    shouldShow.value = true
  }

  const closeDrawer = () => {
    shouldShow.value = false
  }

  return { shouldShow, toggleDrawer, openDrawer, closeDrawer }
}
